import React, {useEffect, useState} from "react";
import {getAirportData, getSuggestions} from "../../../../utils/FlexxAPI";

const PortSearchField = ({name, val, placeholder, onSelect}) => {

  const [loading, setLoading] = useState(false)
  const [active, setActive] = useState(false)
  const [inputVal, setInputVal] = useState(val);
  const [suggestions, setSuggestions] = useState([]);
  const [abortController, setAbortController] = useState(null);

  useEffect(() => {
    if (abortController) {
      abortController.abort();
    }
    const ac = new AbortController();
    setAbortController(ac)
    if (active && inputVal && inputVal.length > 2) {
      setLoading(true);
      try {
        getSuggestions(inputVal, ac.signal).then((response) => {
          setSuggestions(response);
          setLoading(false)
        });
      } catch (e) {}
    }

  }, [inputVal]);

  useEffect(() => {
    if (!val) {
      setInputVal('');
    } else {
      setInputVal(val);
    }
  }, [val])

  const onFocus = () => {
    setActive(true);
  }

  const onBlur = () => {
     setActive(false);
  }

  const handleClick = async (port) => {
    if (port.api) {
      onSelect(port.api);
    } else {
      const portData = await getAirportData(port.iata);
      onSelect(portData);
    }

    setInputVal(port.iata ? port.iata : port.name);
    setActive(false);
  }

  return <>
    <input
      type="text"
      id={name}
      autoComplete={'off'}
      name={name}
      placeholder={placeholder}
      value={inputVal}
      onChange={(e) => {
        setInputVal(e.target.value)
      }}
      onFocus={onFocus}
    />
    {!!(active && (loading || suggestions.length > 0)) && <>
      <div className="flight-calculator__suggestions">
        <div className="flight-calculator__suggestions__inner">

          {!!loading && <>
            Loading
          </>}

          {(!loading && suggestions.length > 0) && <>
            {suggestions.map((suggestion, index) => {
              return <div
                className="flight-calculator__suggestion"
                key={index}
                onClick={() => {
                  handleClick(suggestion)
                }}
              >
                <div className="flight-calculator__suggestion__index">
                  <p>{suggestion.iata ? suggestion.iata : ''}</p>
                </div>
                <div className="flight-calculator__suggestion__name">
                  <p>{suggestion.name}</p>
                </div>
                <div className="flight-calculator__suggestion__flag">
                  {!!suggestion.country && <img
                    src={`_resources/themes/airsprint/images/flags/${suggestion.country.toLowerCase()}.png`}
                    alt={suggestion.country}
                  />}
                </div>
              </div>
            })}
          </>}



        </div>
      </div>
    </>}
  </>

}

export default PortSearchField;
